import { createAction } from '@ngrx/store';

export const addToBasket = createAction('[BASKET] Add', (uid, itemId, item, actualItem) => ({
  uid,
  itemId,
  item,
  actualItem
}));
export const addCountToBasket = createAction('[BASKET] Add Count', (uid, itemId, item, actualItem, count) => ({
  uid,
  itemId,
  item,
  actualItem,
  count
}));
export const removeFromBasket = createAction('[BASKET] Remove', (uid, itemId, item) => ({
  uid,
  itemId,
  item
}));

export const deleteFromBasket = createAction('[BASKET] Delte', (uid, itemId, item) => ({
  uid,
  itemId,
  item
}));

export const resetBasket = createAction('[BASKET] Reset');
